import { render, staticRenderFns } from "./TeacherLogin.vue?vue&type=template&id=56d56892&scoped=true&"
import script from "./TeacherLogin.vue?vue&type=script&lang=js&"
export * from "./TeacherLogin.vue?vue&type=script&lang=js&"
import style0 from "./TeacherLogin.vue?vue&type=style&index=0&id=56d56892&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56d56892",
  null
  
)

export default component.exports